module.exports = __webpack_public_path__ + "img/scythians-barbarian.edbfdde5.png";